import { useEffect, useState } from "react";
import api from "../lib/api";
import LegalDocumentDialog from "./LegalDocumentDialog";

/**
 * The privacy policy edited in Ajustes → Política de privacidad: the same
 * text (and version) people accept on their first login, cookies section
 * included. Pass `policy` when the caller already has it; otherwise it is
 * fetched the first time it opens.
 */
export default function PrivacyPolicyDialog({ open, onOpenChange, policy: given }) {
  const [fetched, setFetched] = useState(null);
  const policy = given || fetched;

  useEffect(() => {
    if (!open || given || fetched) return;
    api
      .get("/auth/policy")
      .then((r) => setFetched(r.data))
      .catch(() => setFetched({ text: "No se pudo cargar la política. Inténtalo de nuevo más tarde.", version: null }));
  }, [open, given, fetched]);

  return (
    <LegalDocumentDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Política de privacidad y protección de datos"
      version={policy?.version}
      text={policy?.text}
      testId="privacy-policy-modal"
    />
  );
}
